module.exports = {"150207001":"沙河街道","150207002":"赛汗街道","150207003":"萨如拉街道","150207004":"白音席勒街道","150207103":"麻池镇","150207105":"哈林格尔镇","150207110":"哈业胡同镇","150207202":"阿嘎如泰苏木乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150207.json
// module id = 363
// module chunks = 0